const category = {
  OPEN: {
    id: 'open',
    name: 'Open',
    order: 0
  },
  ADVANCED: {
    id: 'advanced',
    name: 'Advanced',
    order: 2
  },
  WOMEN: {
    id: 'women',
    name: 'Women',
    order: 3
  },
  NOVICE: {
    id: 'novice',
    name: 'Novice',
    order: 1
  },
  CADET: {
    id: 'cadet',
    name: 'Cadet',
    order: 4
  }
}

const level = {
  CLUB: {
    id: 'club',
    name: 'Club',
    order: 0
  },
  LOCAL: {
    id: 'local',
    name: 'Local',
    order: 1
  },
  REGIONAL: {
    id: 'regional',
    name: 'Regional',
    order: 2
  },
  NATIONAL: {
    id: 'national',
    name: 'National',
    order: 3
  }
}

const scheduleType = {
  CHECKIN: {
    id: 'checkin',
    key: 'checkin',
    label: 'Check In'
  },
  POOLS: {
    id: 'pools',
    key: 'pools',
    label: 'Pools'
  },
  TABLE: {
    id: 'table',
    key: 'table',
    label: 'Bracket'
  },
  BESTOF: {
    id: 'bestof',
    key: 'bestof',
    label: 'Best Of'
  },
  SPLIT: {
    id: 'split',
    key: 'split',
    label: 'Split'
  }
}

const attackType = {
  f: {
    code: 'f',
    name: 'First Contact',
    value: 1
  },
  c: {
    code: 'c',
    name: 'Clean Hit',
    value: 2
  },
  a: {
    code: 'a',
    name: 'Assault',
    value: 2
  },
  n: {
    code: 'n',
    name: 'Late hit',
    value: 2
  },
  i: {
    code: 'i',
    name: 'Indirect',
    value: 1
  },
  r: {
    code: 'r',
    name: 'Return',
    value: 3
  },
  h: {
    code: 'h',
    name: 'Honor',
    value: 1
  },
  v: {
    code: 'v',
    name: 'Delayed assault',
    value: 1
  },
  o: {
    code: 'o',
    name: 'Out of bounds',
    value: 2
  },
  d: {
    code: 'd',
    name: 'Disarm',
    value: 2
  },
  p: {
    code: 'p',
    name: 'Priority',
    value: 1
  },

  s: {
    code: 's',
    name: '2nd Violation',
    value: 1
  },
  t: {
    code: 't',
    name: '3rd Violation',
    value: 1
  }
}

const playerColors = {
  BLUE: '#0080ff',
  ORANGE: '#FFA500',
  Green: '#0BDA51',
  Red: '#ff0800',
  White: '#fff',
  Purple: '#BA55D3',
  Yellow: '#FFFF00',
  Pink: '#FF69B4'
}

export {
  category,
  level,
  scheduleType,
  attackType,
  playerColors
}
